var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('Header'),_c('Hero'),_c('AboutMe'),_c('PortfolioGallery'),_c('Service'),_c('Skills'),_c('Funfact'),_c('Testimonial'),_c('Footer'),_c('OffCanvasMobileMenu'),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }